import type { AcceptInvitationOutcome, AcceptInviteCommand, AcceptInviteResult } from "../model/Invitation";
import type { InvitationService } from "../port/InvitationService";
import type { SessionStore } from "../port/SessionStore";

export class AcceptInvitation {
  constructor(
    private readonly service: InvitationService,
    private readonly sessionStore: SessionStore,
  ) {}

  async execute(
    cmd: AcceptInviteCommand,
    signal?: AbortSignal
  ): Promise<AcceptInvitationOutcome> {
    const res: AcceptInviteResult = await this.service.acceptInvitation(
      cmd,
      signal,
    );

    if (res.nextAction === "OPEN_WEB_DASHBOARD") {
      if (!res.accessToken || !res.accessExpiresAt) {
        throw new Error(
          "Die Einladung wurde angenommen, aber die Anmeldung konnte nicht gestartet werden.",
        );
      }

      this.sessionStore.set({
        accessToken: res.accessToken,
        accessExpiresAt: res.accessExpiresAt,
      });

      return {
        type: "web-dashboard",
        accountId: res.accountId,
        userId: res.userId,
        personId: res.personId,
        role: res.role,
        dashboardPath: "/dashboard",
      };
    }

    return {
      type: "android-app",
      accountId: res.accountId,
      userId: res.userId,
      personId: res.personId,
      role: res.role,
    };
  }
}
